<template>
    <div style="margin-left: 30px;margin-top: -20px;">
        <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" mode="horizontal" @select="handleOpen">
            <el-menu-item index="1">
                <span>初始化设置</span>
            </el-menu-item>
            <el-menu-item index="2" router="true">
                <span slot="title">额度设置</span>
            </el-menu-item>
            <el-menu-item index="5">
                <span>组卷合作机构管理中心</span>
            </el-menu-item>
            <el-menu-item index="4">
                <span>修改记录</span>
            </el-menu-item>
            <el-tooltip class="item" effect="light" placement="left" :value="true">
                <div slot="content" style="color: #F56C6C;font-size: 14px"><b><i class="el-icon-message-solid"></i>修改配置后请点击此处保存</b></div>
                <el-button style="text-align: center;float: right;margin-top: 26px" type=primary size="small" @click="submit">确定</el-button>
            </el-tooltip>
        </el-menu>
        <div v-if="activeIndex==4">
            <recorder :customer_id="$route.query['id']" :product_id="form.product_id" :product_list="params.product_list"></recorder>
        </div>
        <el-row class="tac">
            <el-col :span="23">
                <init-configure v-if="activeIndex == 1" ref="init-configure" :params="form.init" :memo="form.memo"
                                @handleDataInit="handleDataInit" @getMemo="getMemo">
                    <template slot="head">
                        <product-head :params="params" @changeHead="changeHead"></product-head>
                    </template>
                </init-configure>
                <limit-configure v-if="activeIndex == 2 " ref="limit-configure" :params="form.limit_configure"
                                 @handleData="handleData"></limit-configure>
                <div v-if="activeIndex == 3">
                    <relation-form service="zujuan_org" ref="relation-form" :customerId="$route.query['id']"
                                   already-relation="true">
                        <template slot="button">
                            <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini"
                                       @click="showRelation=true">关联账号
                            </el-button>
                            <relation-dialog @relationAccount="relationAccount" service="zujuan_org" title="关联账号"
                                             @handleClose="closeRelationDialog" :customerId="$route.query['id']"
                                             :is-show="showRelation"></relation-dialog>
                        </template>
                    </relation-form>
                </div>
            </el-col>
        </el-row>
        <!--<div slot="footer" class="dialog-footer" style="text-align: center" v-if="activeIndex != 3">-->
            <!--<el-button style="text-align: center" :disabled="is_submit" type=primary @click="submit">确定</el-button>-->
        <!--</div>-->
        <div v-show="activeIndex==5">
            <p>
                <b>（注：组卷合作机构中心的使用期限与组卷合作机构产品的时间一致）</b>
            </p>
            <MenuBind :customer_id="$route.query['id']" :product_id="form.product_id"></MenuBind>
        </div>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }

    .exp {
        color: red;
    }
</style>
<script>
    import LimitConfigure from "~/views/order/zujuan/limitConfigure.vue";
    import InitConfigure from "~/views/order/zujuan/initConfigure.vue";
    import CommonService from "~/services/common";
    import Config from "~/config/params";
    import RelationForm from "~/views/customer/relationForm.vue";
    import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
    import ProductHead from "~/views/order/partial/product_head.vue";
    import OrderService from "~/services/order";
    import Recorder from "~/views/order/recoder/base.vue";
    import MenuBind from "~/views/customer/menu/MenuBind.vue";
    export default {
        components: {
            LimitConfigure,
            InitConfigure,
            RelationForm,
            RelationDialog,
            ProductHead,
            Recorder,
            MenuBind
        },
        data() {
            return {
                is_submit: false,
                is_ajax_loading: false,
                validate_init: true,
                validate_limit_configure: false,
                form: {
                    order_id: '',
                    product_id: '',
                    init: {},
                    limit_configure: {},
                    memo:''
                },
                showRelation: false,
                activeIndex: '1',
                formLabelWidth: '120px',
            };
        },
        props: {
            params: {
                required: true
            }
        },
        created() {
            if (this.params.config.limit_configure) {
                this.form.limit_configure = Object.assign(this.form.limit_configure, this.params.config.limit_configure)
            } else {
                this.default_setting();
            }
            if (typeof this.params.config.init != 'undefined') {
                this.form.init = Object.assign(this.form.init, this.params.config.init)
            }
            this.form.limit_configure.product_code = this.params.product_code;
            this.form.product_id = this.params.product_id;
            this.form.order_id = this.params.order_id;
            this.form.type = this.params.open_state;
            this.form.end_at = this.params.end_at;
            this.form.start_at = this.params.start_at;
            this.form.memo = this.params.config.memo;
        },
        methods: {
            /**
             * 修改头部信息
             * @param data
             */
            changeHead(data) {
                this.form.type = data.type;
                this.form.end_at = data.end_at;
                this.form.start_at = data.start_at;
            },
            getMemo(data) {
                this.form.memo = data.memo
            },
            closeRelationDialog(show) {
                this.showRelation = show;
            },
            /**
             * 关联账号
             * */
            relationAccount(data) {
                this.$refs['relation-form'].getAlready();
            },
            /**
             * 表单提交
             * */
            submit() {
                if (this.is_submit) return false;
                this.is_submit = true;
                if (!this.validate_init) return false;
                OrderService.reviseProduct(this.form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: res.msg == 'success' ? Config.REVISE_NOTICE : res.msg,
                            type: 'success'
                        });
                    }
                    this.is_submit = false;
                });
            },
            /**@description 监听子组件数据 */
            handleData(data) {
                this.form.limit_configure = data
            },

            handleDataInit(data) {
                this.$refs['init-configure'].validateForm((rs) => {
                    this.validate_init = rs;
                })
                this.form.init = data;
            },
            handleDialogConfigureShow() {
                if (this.is_ajax_loading) return;
                if (!this.validate_init) {
                    this.$message({
                        message: '请进行初始化设置或者初始化设置有错误',
                        type: 'error'
                    })
                    return false;
                }
                ;
                if (!this.validate_limit_configure) {
                    this.$message({
                        message: '请进行额度设置或额度设置错误',
                        type: 'error'
                    })
                    return false;
                }
                ;
                this.$emit('handleDialogConfigureShow', this.form);
            },

            handleOpen(key, keyPath) {
                if(key == 3){
                    return false;
                }
                this.activeIndex = key;
            },
            handleDialogConfigureClose() {
                this.$emit('handleDialogConfigureShow', '', this.form.product_id);
            },
            /** 获取学校开通产品的信息 */
            getProductInfo() {
                CommonService.getSchoolProductInfo({
                    customer_id: global.customer_id,
                    product: this.params.code
                }).then(res => {
                    if (res.data) {
                        this.form.init.cor_domain = res.data.domain_url.split('.')[0];
                        this.form.init.cor_domain_url = res.data.domain_url;
                        this.form.init.cor_name = res.data.cor_name;
                        if (res.data.logo_url) {
                            this.form.init.fileList = [{name: '学校Logo展示图片', url: res.data.logo_url}];
                        }
                        this.validate_init = true;
                    }
                })
                if (this.$router.currentRoute.path == '/order/edit') {
                    this.validate_init = true;
                    this.validate_limit_configure = true;
                }
            },
            /**
             *加载默认配置
             * */
            default_setting() {
                let data = {};
                data.question_num = 50;
                data.paper_download = 150;
                data.single_down_limit = 100;
                let subjects = Config.getSubjects();
                subjects.unshift({
                    subject_id: 0,
                    subject_name: '所有科目',
                });
                data.batch = subjects.map(item => {
                    item.config = Object.assign({}, {
                        all: 0,
                        primary: -1,
                        middle: -1,
                        high: -1
                    });
                    global.periods.forEach(period => {
                        if (period == 1) {
                            item.config.primary =  30;
                            item.config.primary =  30;
                        } else if (period == 2) {
                            item.config.middle =  30;
                            item.config.middle =  30;
                        } else if (period == 3) {
                            item.config.high =  30;
                            item.config.high =  30;
                        }
                    })
                    return item;
                })
                this.validate_limit_configure = true;
                this.form.limit_configure = data;
                this.$emit('handleDialogConfigureShow', this.form);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/zujuan/zujuanCorConfigure.vue